/*
登陆的路由组件
 */
import React, { Component } from 'react';
import { Layout, Menu, Button, Dropdown } from 'element-react';
import $ from 'jquery';
import { getLoginShopInfo, systemConfig } from '../../utils/http';
import { GetSystemUrlRequest } from '../../utils/api';
import { withRouter } from 'react-router-dom';

class NavMenu extends Component {
  state = {
    listsNavTop:
      //  !systemConfig.isZk5() ? 
      // [
      //   // { title: '首页', linkName: 'index', icon: 'icon-zhuye', fontSize: '16px', isNextNav: false },
      //   // { title: '货源中心', linkName: 'offerSearch', icon: 'icon-daifa', fontSize: '16px', isNextNav: false },  
      //   {
      //     title: '商品铺货', linkName: 'noUrl', icon: 'icon-fenfa1', fontSize: '16px', isNextNav: true, isShowMore: true,
      //     children: [
      //       { title: '货源中心', linkName: 'offerSearch', icon: 'icon-zhuye', fontSize: '15px', isShow: true },
      //       { title: '链接铺货', linkName: 'index', icon: 'icon-zhuye', fontSize: '16px', isShow: true },
      //       { title: '铺货日志', linkName: 'distributionLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
      //       { title: '铺货设置', linkName: 'distributionSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
      //     ]
      //   },

      //   {
      //     title: '商品管理', linkName: 'proxyProductManger', icon: 'icon-chanpinguanli', fontSize: '13px', isNextNav: true, isShowMore: true,
      //     children: [
      //       { title: '供应商', linkName: 'supplierMarke', icon: 'icon-fenfa1', fontSize: '16px', isShow: false },
      //       { title: '代销商品', linkName: 'proxyProduct', icon: 'icon-fenfa1', fontSize: '16px', isShow: true },
      //       { title: '店铺商品', linkName: 'shopProduct', icon: 'icon-dianpu', fontSize: '16px', isShow: true },
      //       { title: '修改价格', linkName: 'batchUpdatePrice', icon: 'icon-dianpu', fontSize: '16px', isShow: false }
      //     ]
      //   },

      //   {
      //     title: '订单管理', linkName: 'procurementOrder', icon: 'icon-guanli', fontSize: '15px', isNextNav: true, isShowMore: true,
      //     children: [
      //       { title: '采购订单', linkName: 'procurementOrder', icon: 'icon-ruku', fontSize: '16px', isShow: true },
      //     ]
      //   },
      //   {
      //     title: '系统设置', linkName: 'noUrlBySystemSet', icon: 'icon-shezhi1', fontSize: '13px', isNextNav: true, isShowMore: true,
      //     children: [
      //       { title: '订单回流设置', linkName: 'orderBackflowSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
      //       { title: '自动售后设置', linkName: 'autoAfterSaleSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
      //     ]
      //   },
      //   {

      //     title: '日志管理', linkName: 'noUrlBySystemLog', icon: 'icon-fuzhi', fontSize: '14px', isNextNav: true, isShowMore: false,
      //     children: [
      //       { title: '自动下单日志', linkName: 'orderBackflowLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
      //       { title: '自动售后日志', linkName: 'autoAfterSaleLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
      //     ]
      //   },
      //   // { title: '我的店铺', linkName: 'myShopList', icon: 'icon-user-follow-line', fontSize: '18px', isNextNav: false },
      //   { title: '授权与多店铺', linkName: 'myAuth', icon: 'icon-user-follow-line', fontSize: '16px', isNextNav: false },
      // ] : 
    [
      // { title: '首页', linkName: 'index', icon: 'icon-zhuye', fontSize: '16px', isNextNav: false },
      // { title: '货源中心', linkName: 'offerSearch', icon: 'icon-daifa', fontSize: '16px', isNextNav: false },  
      {
        title: '商品铺货', linkName: 'noUrl', icon: 'icon-fenfa1', fontSize: '16px', isNextNav: true, isShowMore: true,
        children: [
          { title: '1688低价货源搜索', linkName: 'alibabaSearchProduct',icon: 'icon-zhuye', fontSize: '16px', isShow: true },
          { title: '1688低价货源推荐', linkName: 'alibabaRecommendProduct',icon: 'icon-zhuye', fontSize: '16px', isShow: true },
          { title: '分销严选', linkName: 'offerSearch', icon: 'icon-zhuye', fontSize: '15px', isShow: true },
          { title: '链接铺货', linkName: 'index', icon: 'icon-zhuye', fontSize: '16px', isShow: true }, 
          { title: '铺货日志', linkName: 'distributionLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
          { title: '铺货设置', linkName: 'distributionSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
        ]
      },

      {
        title: '商品管理', linkName: 'proxyProductManger', icon: 'icon-chanpinguanli', fontSize: '13px', isNextNav: true, isShowMore: true,
        children: [
          { title: '代销商品', linkName: 'proxyProduct', icon: 'icon-fenfa1', fontSize: '16px', isShow: true },
          { title: '店铺商品', linkName: 'shopProduct', icon: 'icon-dianpu', fontSize: '16px', isShow: true },
          { title: '修改价格', linkName: 'batchUpdatePrice', icon: 'icon-dianpu', fontSize: '16px', isShow: false },
          { title: '商品图文', linkName: 'productImageText', icon: 'icon-ruku', fontSize: '16px', isShow: false },
        ]
      },

      {
        title: '订单管理', linkName: 'procurementOrder', icon: 'icon-guanli', fontSize: '15px', isNextNav: true, isShowMore: true,
        children: [
          // { title: '采购订单', linkName: 'procurementOrder', icon: 'icon-ruku', fontSize: '16px', isShow: true },
          { title: '采购订单', linkName: 'orderList', icon: 'icon-ruku', fontSize: '16px', isShow: true },
          { title: '下单设置', linkName: 'supplierMarke', icon: 'icon-fenfa1', fontSize: '16px', isShow: true }
        ]
      },
      {
        title: '售后管理', linkName: 'afterSalesManagement', icon: 'icon-guanli', fontSize: '15px', isNextNav: true, isShowMore: true,
        children: [
          { title: '官方仓售后单', linkName: 'officialWarehouseAfterSalesOrder', icon: 'icon-ruku', fontSize: '16px', isShow: true },
          { title: '官方退货仓', linkName: 'officialReturnWarehouse', icon: 'icon-fenfa1', fontSize: '16px', isShow: true }
        ]
      },
      {
        title: '系统设置', linkName: 'noUrlBySystemSet', icon: 'icon-shezhi1', fontSize: '13px', isNextNav: true, isShowMore: true,
        children: [
          { title: '订单回流设置', linkName: 'orderBackflowSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
          { title: '自动售后设置', linkName: 'autoAfterSaleSet', icon: 'icon-shezhi2', fontSize: '16px', isShow: true },
        ]
      },
      {

        title: '日志管理', linkName: 'noUrlBySystemLog', icon: 'icon-fuzhi', fontSize: '14px', isNextNav: true, isShowMore: false,
        children: [
          { title: '自动下单日志', linkName: 'orderBackflowLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
          { title: '自动售后日志', linkName: 'autoAfterSaleLog', icon: 'icon-rizhi', fontSize: '16px', isShow: true },
        ]
      },
      // { title: '我的店铺', linkName: 'myShopList', icon: 'icon-user-follow-line', fontSize: '18px', isNextNav: false },
      { title: '授权与多店铺', linkName: 'myAuth', icon: 'icon-user-follow-line', fontSize: '16px', isNextNav: false },
    ]



  };
  componentWillMount() {
    const proxyProductManger = this.state.listsNavTop.find(s => s.linkName == 'proxyProductManger');
    if ((systemConfig.isTouTiao() || systemConfig.isKuaiShou()) && proxyProductManger) {
      const supplierMarkeMenu = proxyProductManger.children.find(s => s.linkName == "supplierMarke");
      const batchUpdatePriceMenu = proxyProductManger.children.find(s => s.linkName == "batchUpdatePrice");
      const productImageTextMenu = proxyProductManger.children.find(s => s.linkName == "productImageText");
      if (supplierMarkeMenu)
        supplierMarkeMenu.isShow = true;
      if (batchUpdatePriceMenu && systemConfig.isTouTiao())
        batchUpdatePriceMenu.isShow = true;
      
      if(productImageTextMenu && systemConfig.isTouTiao() && (systemConfig.isZk1() || systemConfig.isZk5()))
        productImageTextMenu.isShow = true;
    }
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('isShowBannerObj');
    });

  }
  componentDidMount() {
    // this.changeNavs(this.props.defaultActive);
    let className = this.props.location.pathname.substr(1);
    if (className && className.indexOf('token=') > -1) {
      className = className.substring(0, className.indexOf('token='))
    }
    if (className && className.indexOf('?') > -1) {
      className = className.substring(0, className.indexOf('?'))
    }

    if (!className) className = "myAuth";
    $("." + className).addClass("is-active");

    setTimeout(() => {
      this.isShowMenu();//隐藏的菜单，按需要显示
    }, 500);
  }

  isShowMenu = () => {

    //后续哪个页面按版本显示导航栏的。这里加下
    let startNum = 0;
    let navTimer = null;
    navTimer = setInterval(() => {
      var shopInfo = getLoginShopInfo();
      if (shopInfo.loginShopPlatformType == "TouTiao" || shopInfo.loginShopPlatformType == "KuaiShou") {
        if (shopInfo.loginShopPlatformType == "TouTiao") {
          let listsNavTop = this.state.listsNavTop;
          listsNavTop.forEach((item, index) => {
            if (item.isNextNav) {
              item.children.forEach((chItem, chIndex) => {
                if (chItem.linkName == "batchUpdatePrice")
                  chItem.isShow = true;
                else if(chItem.linkName == 'productImageText' )//&& (systemConfig.isZk1() || systemConfig.isZk5())
                  chItem.isShow = true;
              })
            }
          })
        }
        let proxyProductMenu = this.state.listsNavTop.find(s => s.linkName == 'proxyProductManger');
        if (proxyProductMenu) {
          let supplierMarkeMenu = proxyProductMenu.children.find(s => s.linkName == 'supplierMarke');
          if (supplierMarkeMenu) supplierMarkeMenu.isShow = true;
        }

        this.setState({});
        clearInterval(navTimer);//清除延时器
      } else {
        startNum = startNum - 0 + 1;
      }
      if (startNum >= 20) { //超过10秒 清除延时器
        clearInterval(navTimer);//清除延时器
      }
    }, 500);

  }




  changeNavs = (hashName) => {
    if (this.props.changeNav)
      this.props.changeNav(hashName);
    else {
      const path = {
        pathname: hashName,
        param: {
          fromMenu: true
        }
      }
      this.props.history.push(path);
    }
    let className = hashName.substr(1);
    setTimeout(() => {
      $(".el-menu-item").each((index, item) => {
        $(item).removeClass("is-active");
      })
      $("." + className).addClass("is-active");

    }, 100)
  }
  showMoreNav = (linkName) => {
    let listsNavTop = this.state.listsNavTop;
    listsNavTop.forEach((item) => {
      if (item.linkName == linkName) {
        item.isShowMore = !item.isShowMore;
      }
    })
    this.setState({
      listsNavTop
    })

  }


  onOpen() {

  }

  onClose() {

  }


  render() {
    return (
      <Menu defaultOpeneds="['set','manP','manL']" className="el-menu-vertical-demo" >
        <ul className="el-menu el-menu-vertical-demo" style={{marginBottom:'100px'}}>
          {
            this.state.listsNavTop.filter(s => systemConfig.isTouTiao() ? true : s.linkName != 'afterSalesManagement').map((item) =>
              item.isNextNav ?
                <li className={"el-submenu is-opened li-"+ item.linkName}>
                  <div className="el-submenu__title" onClick={() => this.showMoreNav(item.linkName)}>
                    <i className={'iconfont ' + item.icon} style={{ fontSize: item.fontSize }}></i>
                    <span>{item.title}</span>
                    <i className={item.isShowMore ? "el-submenu__icon-arrow el-icon-arrow-down" : "el-submenu__icon-arrow el-icon-arrow-down active"} ></i>
                  </div>
                  <div className="collapse-transition" data-old-padding-top="" data-old-padding-bottom="" data-old-overflow="hidden"
                    style={{ overflow: 'hidden', display: item.isShowMore ? "block" : "none" }}>
                    <ul className="el-menu">

                      {
                        item.children.map((cItem) =>
                          <li style={cItem.isShow ? { display: "flex" } : { display: "none" }} className={"el-menu-item " + cItem.linkName} onClick={() => this.changeNavs('/' + cItem.linkName)}>{cItem.title}</li>

                        )
                      }

                    </ul>
                  </div>
                </li>
                :
                <li className={"el-menu-item li-"+ item.linkName+" " + item.linkName} onClick={() => this.changeNavs('/' + item.linkName)}><i className={'iconfont ' + item.icon} style={{ fontSize: item.fontSize }}></i>{item.title}</li>
            )
          }

        </ul>
      </Menu>

    )
  }
}

export default withRouter(NavMenu);


// WEBPACK FOOTER //
// ./src/components/navMenu/navMenu.jsx